import { createGlobalStyle } from 'styled-components'

import { Theme } from '@application/Interfaces/Themes/ThemeType'

import './App.css'

export const GlobalAppStyles = createGlobalStyle<{ theme: Theme }>`
  html {
    box-sizing: border-box;
    text-size-adjust: 100%;
    scroll-behavior: smooth;
  }

  body {
    font-family: 'Poppins', sans-serif;
    font-weight: 400;
    -webkit-font-smoothing: antialiased;
    margin: 0;
    font-size: 1rem;
  }

  html * {
    box-sizing: inherit;
  }

  /* https://cssreset.com/scripts/eric-meyer-reset-css/ */
  /* http://html5doctor.com/html-5-reset-stylesheet/ */
  *, h1 {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }

  hr {
    border-top: 1px inset;
  }

  /* From  defaultRootStyle in /imports/app/molecules/Buttons/Button/styles */
  button {
    cursor: pointer;

    &:focus {
      outline: none;
    }
  }

  body.using-mouse &:focus {
    outline: none;
    box-shadow: none;
  }

  li.root {
    display: block;
  }

  /* This is a rule to hide all marketing pixels which are attached to body. */
  /* In some cases they are causing visual artifacts, that's why we always want to be sure */
  /* that they are hidden */
  body > img {
    position: absolute;
    top: 0;
    right: 200%;
  }

  img {
    pointer-events: none;
  }

  body.no-js .reveal {
    opacity: 1 !important;
    transform: none !important;
  }

  .custom-button {
    outline: 0;
    border: 0;
    margin: 0;

    display: flex;
    align-items: center;
    cursor: pointer;
    font-family: Poppins, sans-serif;
    letter-spacing: inherit;
    font-weight: 600;
    padding: 12px 16px;
    border-radius: 3px;
    font-size: 14px;
    line-height: 180%;


    background-color: rgb(26, 78, 192);
    color: rgb(255, 255, 255);
    text-transform: uppercase;
  }

  .custom-button.disabled {
    color: rgb(98, 116, 149);
    background-color: rgb(174, 184, 203);
  }

  .salesforce-chat-button {
    cursor: pointer;
    margin: 0 auto;
    position: fixed;
    bottom: 0;
    right: 2%;
    z-index: 999;
  }


`
